// Corporate brand social media accounts (76UNBOXED).
// Used by the landing-site footer; available for any other public surface
// that needs to point at the company's social presence.
//
// Note: per-district social URLs live on the `District` type and are rendered
// by `district-footer.tsx` — that's a different concern (URLs vary per
// district) so the two don't share data.
export const socialLinks = [
    { url: 'https://facebook.com/76UNBOXED', icon: 'bi-facebook', label: 'Follow 76UNBOXED on Facebook' },
    { url: 'https://instagram.com/76UNBOXED', icon: 'bi-instagram', label: 'Follow 76UNBOXED on Instagram' },
    { url: 'https://linkedin.com/company/76UNBOXED', icon: 'bi-linkedin', label: 'Follow 76UNBOXED on LinkedIn' },
    { url: 'https://youtube.com/@76UNBOXED', icon: 'bi-youtube', label: 'Follow 76UNBOXED on YouTube' },
    { url: 'https://pinterest.com/76UNBOXED', icon: 'bi-pinterest', label: 'Follow 76UNBOXED on Pinterest' },
];
